import { render } from "./StockContainer.vue?vue&type=template&id=6c94d3d2"
import script from "./StockContainer.vue?vue&type=script&lang=js"
export * from "./StockContainer.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\glenn.degroot\\source\\Giant.B2C\\Giant.Website\\vue-apps\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__